import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import LoginPage from "@/pages/LoginPage";
import ZicassoDashboard from "@/pages/zicasso/ZicassoDashboard";
import ZicassoBestPractices from "@/pages/zicasso/ZicassoBestPractices";
import TasksPage from "@/pages/zicasso/TasksPage";
import SettingsPage from "@/pages/zicasso/SettingsPage";
import RemindersPage from "@/pages/zicasso/RemindersPage";
import SupervisionPage from "@/pages/zicasso/SupervisionPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/app/leads" replace />} />
            <Route path="leads" element={<ZicassoDashboard />} />
            <Route path="tasks" element={<TasksPage />} />
            <Route path="best-practices" element={<ZicassoBestPractices />} />
            <Route path="reminders" element={<RemindersPage />} />
            <Route path="supervision" element={<SupervisionPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/app" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
